import { render, staticRenderFns } from "./vip-drawer.vue?vue&type=template&id=7167ea5e&"
import script from "./vip-drawer.vue?vue&type=script&lang=js&"
export * from "./vip-drawer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports